/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { Chrome as ChromeComponent } from 'vue-color';

  import ApplicationState        from 'g3w-state';
  import GUI                     from 'g3w-app';
  import { getCatalogLayerById } from 'utils/getCatalogLayerById';
  import { downloadFeatures }    from 'utils/downloadFeatures';
  import { copyUrl }             from 'utils/copyUrl';
  import { gettext as _ }        from 'g3w-i18n';

  /**
   * @see https://www.w3schools.com/howto/howto_js_draggable.asp 
   */
   function dragElement(menu) {
    const el = menu.querySelector('li.title');
    if (!el || menu._drag) {
      return;
    } else {
      menu._drag = true;
    }
    let x2 = 0, y2 = 0, x1 = 0, y1 = 0;
    el.addEventListener('mousedown', function(e) {
      // skip dragging on form elements
      if (['.select2-container', 'button', 'select', 'input', 'textarea', 'x-select'].some(i => e.target.closest(i))) {
        return;
      }
      e.preventDefault();
      x1 = e.clientX;
      y1 = e.clientY;
      document.addEventListener('mouseup', mouseUp);
      document.addEventListener('mousemove', mouseMove);
    });
    function mouseUp() {
      document.removeEventListener('mouseup', mouseUp);
      document.removeEventListener('mousemove', mouseMove);
    }
    function mouseMove(e) {
      e.preventDefault();
      x2 = x1 - e.clientX;
      y2 = y1 - e.clientY;
      x1 = e.clientX;
      y1 = e.clientY;
      if (menu.style.marginLeft) { x2 -= parseInt(menu.style.marginLeft); menu.style.marginLeft = null; }
      if (menu.style.marginTop)  { y2 -= parseInt(menu.style.marginTop);  menu.style.marginTop  = null; }
      menu.style.top  = (menu.offsetTop - y2)    + "px";
      menu.style.left = (menu.offsetLeft - x2) + "px";
    }
  }

  const __vue_script__ = {
    name: 'context-menu',

    props: {
      external: {
        type: Object
      }
    },

    data() {
      return {
        ApplicationState,
        layerstree:       null,
        layer:            null,
        top:              0,
        left:             0,
        context:          null,
        map_coords:       [],
        items:            [], /**@since 4.1.0 store custom items add from plugins/custom.js */
      };
    },

    computed: {

      edit_url() {
        return ApplicationState.project.getState().edit_url;
      },

      layers_url() {
        return ApplicationState.project.getState().layers_url;
      },

      initConfig() {
        return window.initConfig;
      },

    },

    components: {
      'chrome-picker': ChromeComponent,
    },

    methods: {

      /**
       * @since 3.10.0
       */
       async onShowContextMenu(e, layerstree) {
        this.closeMenu();

        this.layerstree = layerstree;

        await this.$nextTick();

        this.left   = e.x;
        this.top    = e.y;

        const layer = !layerstree?.nodes && layerstree; // check for "layer" or "group"
        this.layer  = layer || null;

        // click on catalog tree (node)
        if (!!layer) {
          this.context = 'layer';
        }

        // click on catalog tree (root)
        if (layerstree && !layer) {
          this.context = 'project';
        }

        // click on canvas (map)
        if (!layerstree && !layer) {
          this.context = 'map'; 
        }

        /**
         * @since 4.1.0 custom context menu items
         * 
         * Example: Single item addition
         * ```js
         * GUI.on('map:context-menu', menu => {
         *   menu.items.push({
         *     icon: 'pencil',
         *     label: 'TEST',
         *     cbk: () => alert('Test'),
         *     position: 0,
         *   });
         * });
         * ```
         * Example : Item with children (sub menu)
         * ```js
         * GUI.on('layer:context-menu', menu => {
         *   menu.items.push({
         *     icon: 'pencil',
         *     label: 'TEST CHILDREN',
         *     children: [{ label: 'Child 1', cbk: () => alert('child 1') }],
         *     position: 100,
         *   });
         * });
         * ```
         */
        GUI.emit(`${this.context}:context-menu`, this);

        await this.$nextTick();

        // open menu at catalog entry
        if (['layer','project'].includes(this.context)) {
          this.top = e.target.getBoundingClientRect().top - this.$refs.menu.clientHeight + (e.target.clientHeight / 2);
        }

        // handle context menu on mobile
        if (window.innerWidth < 767) {
          this.left = (window.innerWidth / 2) - (this.$refs.menu.clientWidth / 2);
          this.top  = (window.innerHeight / 2) - (this.$refs.menu.clientHeight / 2);
        }

        dragElement(this.$refs.menu);

        const rect = this.$refs.menu.getBoundingClientRect();

        // prevent right overflow (page) 
        if (rect.right > window.innerWidth) {
          this.left = window.innerWidth - rect.width;
        }

        // prevent bottom overflow (page) 
        if (rect.bottom > window.innerHeight) {
          this.top = window.innerHeight - rect.height;
        }
      },

      showDownloadMenu(layer) {
        downloadFeatures({ layer });
        this.closeMenu();
      },

      /**
       * @param { string } menu
       */
      closeMenu() {
        this.context      = null;
        this.items.length = 0;
        this.layerstree   = null;
      },

      onChangeColor(val) {
        this.layer.color         = val;
        this.$refs.layer_color.style.backgroundColor = val.hex;
        const layer              = GUI.getLayerByName(this.layer.name || '');
        const style              = layer.getStyle();
        style._g3w_options.color = val;
        layer.setStyle(style);
      },

      /**
       * @param { string } format
       * @param { string } layerId
       * 
       * @since 3.11.0
       */
      canDownload(layerId) {
        // exclude pdf format. It is used only for single feature download
        return getCatalogLayerById(layerId)?.getDownloadFormats()?.filter(f => 'pdf' !== f)?.length;
      },

      /**
       * @param { 'top', 'bottom' } position 
       */
      setLayerPosition(position) {
        if (position !== this.layer.position) {
          this.layer.position = position;
          const layer = GUI.getLayerById(this.layer.id);
          layer.setZIndex(({ top: GUI.layersCount, bottom: 0 })[position]);
          layer.set('position', position);
          this.closeMenu();
        }
      },

      /**
       * @TODO refactor this, almost the same as: `CatalogTree.vue::zoomToLayer(layer))`
       *
       * @FIXME add description
       *
       * @param layer
       */
      zoomToLayer(layer) {
        try {
          let bbox = [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy];
          let epsg = layer.epsg || GUI.getEpsg();
          bbox = epsg === GUI.getEpsg() ? bbox : ol.proj.transformExtent(bbox, epsg, GUI.getEpsg());
          const geometry = ol.extent.containsExtent(ApplicationState.project.state.extent, bbox) ? bbox : ApplicationState.project.state.extent;
          const view = GUI.getMap().getView();
          view.animate(
            { duration: 200, center:     view.getCenter() },
            { duration: 200, resolution: view.getResolution() }
          );
          view.fit(geometry, { constrainResolution: true, size: GUI.getMap().getSize() });
        } catch(e) {
          console.warn(e);
          GUI.showUserMessage({
            type:        'alert',
            message:     `${e.message}`,
            textMessage: true,
          })
        }
        this.closeMenu();
      },

      /**
       * @returns {Boolean} whether layer is editable
       * @since 3.11.0
       */
       canEdit(layer) {
        return layer 
          ? !layer.external && getCatalogLayerById(layer.id).isEditable() && getCatalogLayerById(layer.id).config.editing?.visible
          : Object.values(GUI.getPlugin('editing')?.getEditableLayers() || {}).find(l => l.isGeoLayer() && !l.isInEditing());
      },

      /**
       * @since 4.1.0
       */
      editableGeometryLayers() {
        return Object.values(GUI.getPlugin('editing')?.getEditableLayers() || {}).filter(l => l.isGeoLayer());
      },

      /**
       * @since 3.11.0
       */
      async startEditing(layer) {
        //store toolboxes id 
        const toolboxes = [];
        if (layer) {
          toolboxes.push(layer.id);
        }

        //In case of no layer, right click on group on TOC
        //get layers belog to groups that are editable
        if (!layer && false === this.layerstree?.root) {
          const traverse = n => {
            if (n.id && getCatalogLayerById(n.id).isEditable()) { toolboxes.push(n.id) }
            if (n.nodes) { n.nodes.forEach(traverse); }
          };
          traverse(this.layerstree);
        }
          
        this.closeMenu();
        const editing = GUI.getPlugin('editing');
        //check if has coordinates
        if (2 === this.map_coords.length) {
          try {
            const project  = ApplicationState.project;
            const response = await GUI.getData('query:coordinates', {
              inputs: {
                coordinates:           this.map_coords,
                feature_count:         project.state.feature_count || 5,
                query_point_tolerance: project.getQueryPointTolerance(),
                layerIds:              [layer.id], //get layerId of editibale layers          
              },
              outputs: false //no content is show
            });
            if (response?.result && response?.data?.length) {

              if (response?.data[0]?.features?.length) {
                
                editing.getToolBoxById(layer.id).start({
                  filter: { fids: response?.data[0]?.features.map(f => f.getId()).join(',') }
                });
                
              } 
            }
          } catch(e) {
            console.warn('Error running spatial query: ', e);
          }
          editing.showPanel({ toolboxes });
          return;

        }

        //Show all editing panel
        if (0 === toolboxes.length) {
          editing.showPanel();
          return;
          
        }

        //show some editing layers 
        editing.showPanel({ toolboxes });
        
        //In case of just on layer in editing, start editing
        if (1 === toolboxes.length) {
          editing.startEditing(toolboxes[0]);
        }

      },

      /**
       * @TODO refactor this, almost the same as: `CatalogTree.vue::canZoom(layer))`
       *
       * Check if layer has bbox property
       *
       * @param layer
       */
      canZoom(layer) {
        return (layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(coord => coord > 0));
      },

      getGeometryType(layerId, external=false) {
        const layer = external ? ApplicationState.catalog.external.vector.find(l => layerId === l.id) : getCatalogLayerById(layerId);
        if (layer) {
          const type = external ? layer.geometryType : layer.config.geometrytype;
          return layer && 'NoGeometry' !== type && type || '';
        }
        return '';
      },

      showAttributeTable(layerId) {
        getCatalogLayerById(layerId).openAttributeTable();
        this.closeMenu();
      },

      async showMetadata(layerId){
        this.closeMenu();
        $('#modal-metadata').modal('show');
        if (layerId) {
          setTimeout(() => {
            document.querySelector('#modal-metadata [href="#metadata_layers"]').click();
            setTimeout(() => {
              //close all open details eventually
              document.querySelectorAll('#metadata_layers summary').forEach(s => s.parentElement.removeAttribute('open'));
              const dom = document.querySelector(`summary:has(+ ul a[href="#layer_general_${layerId}"])`);
              //skin when no layer is found on layers metadata tab
              if (!dom) {
                return;
              }
              dom.scrollIntoView();
              //click if only is no open tab
              if (!dom.parentElement.hasAttribute('open')) {
                dom.click();
              }
            });
          });
        } else {
          setTimeout(() => {
            document.querySelector('#modal-metadata [href="#metadata_general"]').click();
          });
        }
      },

      async setLayerStyle(style) {
        try {
          //change layer style
          await getCatalogLayerById(this.layer.id).changeStyle(style);
          ApplicationState.map_theme.theme = null; // @since 4.0.7 on group or layer change , set map_theme null
        } catch (e) {
          console.warn(e);
        }
        this.closeMenu();
      },

      /**
       * Set current filter
       *
       * @param filter
       *
       * @since 3.9.0
       */
      async setLayerFilter(filter) {
        const changed = (
          null === this.layer.filter.current ||
          filter.fid !== this.layer.filter.current.fid 
        );
        const layer = getCatalogLayerById(this.layer.id);
        if (changed) {
          await layer.applyToken(filter);
        } else {
          await layer.deleteToken();
        }
        layer.change();
        this.closeMenu();
      },

      /**
       * Delete filter from saved filters
       *
       * @param fid
       *
       * @returns { Promise<void> }
       *
       * @since 3.9.0
       */
      async deleteFilter(fid) {
        const layer  = getCatalogLayerById(this.layer.id);
        // No found catalog layer
        if (!layer) { return }
        const change = fid === this.layer.fid;
        await layer.deleteToken(fid);
        if (change) { layer.change() }
        this.closeMenu();
      },

      /**
       * Context menu: toggle "styles" submenu handling its correct horizontal and vertical alignment
       * 
       * @param { string } menu
       * @param { HTMLElement } target
       */
      async showMenu(e) {
        const li = e.target.closest('li');
        const ul = li && li.querySelector('ul');
        if (ul) {
          const overflowY    = (ul.offsetHeight + ul.getBoundingClientRect().top) >= (this.$refs.menu.offsetHeight + this.$refs.menu.getBoundingClientRect().top);
          ul.style.top       = ul.offsetHeight > this.$refs.menu.offsetHeight ? 0 : undefined;
          ul.style.left      = this.$refs.menu.offsetWidth -2 + 'px';
          ul.style.maxHeight = this.$refs.menu.offsetHeight + 'px';
          ul.style.bottom    = overflowY ? 0         : undefined;
          ul.style.marginTop = overflowY ? undefined : '-5px';
          ul.style.overflowY = 'auto';
        }
      },

      /**
       * @since 3.10.0
       */
      canOpenAttributeTable(layer) {
        return layer.openattributetable;
      },

      /**
       * @since 3.10.0
       */
      isExternalLayer(layer) {
        return !layer.projectLayer;
      },

      /**
       * @since 4.1.0
       */
      isExternalImageLayer(layer) {
        return !layer.projectLayer && ['wms', 'tms'].includes(layer._type);
      },

      /**
       * @since 3.8.3
       */
      isExternalVectorLayer(layer) {
        return !layer.projectLayer && 'vector' === layer._type;
      },

      /**
       * @since 3.8.3
       */
      canShowStylesMenu(layer) {
        return layer?.styles?.length > 1;
      },

      /**
       * @returns { boolean } whether it can show filters menu
       *
       * @since 3.9.0
       */
      canShowFiltersMenu(layer) {
        return layer?.filters?.length > 0;
      },

      /**
       * @since 3.8.3
       */
      hasMetadata(layer) {
        return layer?.metadata;
      },

      /**
       * @since 3.8.3
       */
      canShowOpacityPicker(layer) {
        return layer.geolayer && layer.visible;
      },

      /**
       * @param {{ id:? string, value: number }}
       * 
       * @fires GUI~layer-change-opacity since 4.1.0
       * 
       * @since 3.11.0
       */
      onLayerOpacity() {
        if (this.isExternalImageLayer(this.layer)) {
           GUI.getLayerById(this.layer.id)?.setOpacity(Number(this.layer.opacity));
        } else {
          getCatalogLayerById(this.layer.id)?.change?.();
        }

      },

      /**
       * @since 4.1.0
       */
      async copyCoords() {
        this.closeMenu();
        const map    = GUI.getMap();
        const view   = map.getView();
        view.animate({ center: this.map_coords, zoom: view.getZoom(), duration: 200 });
        copyUrl(this.map_coords.join(', '));
      },

      /**
       * @since 4.1.0
       */
      async queryCoords() {
        this.closeMenu();
        try {
          const project = ApplicationState.project;
          await GUI.getData('query:coordinates', {
            inputs: {
              coordinates:           this.map_coords,
              feature_count:         project.state.feature_count || 5,
              query_point_tolerance: project.getQueryPointTolerance(),
              multilayers:           [].concat(project.state.querymultilayers).includes(this.name),
            }
          });
        } catch(e) {
          console.warn('Error running spatial query: ', e)
        }
      },

      /**
       * @since 4.1.0
       */
      zoomIn() {
        this.closeMenu();
        const map    = GUI.getMap();
        const view   = map.getView();
        view.animate({ center: this.map_coords, zoom: view.getZoom() + 1, duration: 200 });
      },

      /**
       * @since 4.1.0
       */
      zoomOut() {
        this.closeMenu();
        const map    = GUI.getMap();
        const view   = map.getView();
        view.animate({ center: this.map_coords, zoom: view.getZoom() - 1, duration: 200 });
      },

      /**
       * @since 4.1.0
       */
      zoomHome() {
        this.closeMenu();
        const map = GUI.getMap();
        const view = map.getView();
        const extent = GUI.project.state.extent;
        view.fit(extent, { duration: 200 });
      },

      /**
       * @since 4.1.0
       */
      showStreetView() {
        this.closeMenu();
        GUI.getMapControl('streetview').showStreetView(this.map_coords);
      },

      /**
       * @since 4.1.0
       */
      showAnnotation() {
        this.closeMenu();
        GUI.getMapControl('annotation').toggle();
      },

      /**
       * @since 4.1.0
       */
      showLegend() {
        this.closeMenu();
        GUI.showLegendPanel();
      },

      /**
       * @since 4.1.0
       */
      takeScreenshot() {
        this.closeMenu();
        GUI.getMapControl('screenshot').toggle(true);
      },

      /**
       * @since 4.1.0
       */
      async showEmbedModal() {
        this.closeMenu();
        await GUI.getPermalink(new URL(window.location.href), {});
      },

    },

    /**
     * @listens GUI~context-menu
     */
    async created() {

      GUI.on('context-menu', this.onShowContextMenu);
      
      // auto-close context menu on Esc key
      document.addEventListener('keyup', e => {
        if ('Escape' === e.key) {
          this.closeMenu();
        }
      });

      // auto-close context menu when clicking outside
      document.addEventListener('click', e => {
        if (this.context && !this.$el.contains(e.target)) {
          e.stopPropagation();
          this.closeMenu();
        }
      }, true);

      await GUI.isReady();
      await GUI.isMapReady()

      // handle click on map
      GUI.getMap().on(['singleclick', 'contextmenu'], e => {
        const ctx  = 'contextmenu' == e.type;
        const ctrl = GUI.getCurrentToggledMapControl();
        // avoid conflict with measure control (right click to undo last added vertex)
        if ('measure' === ctrl?.name || false === GUI.getMap().get('can_show_context_menu')) {
          return;
        }
        // suppress built-in context menu (from browser)
        if (ctx) {
          e.preventDefault();
        }
        // show our custom context menu
        if (ctx || (!ctrl && !GUI.getPlugin('editing')?.getLayers?.()?.some?.(l => l.isInEditing()))) {
          this.map_coords = GUI.getMap().getCoordinateFromPixel([e.pixel[0], e.pixel[1]]);
          GUI.emit('context-menu', e.originalEvent);
        }
      });
    
    },


  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.context)?_c('ul',{ref:"menu",staticClass:"context-menu",style:({
    top:  _vm.top + 'px',
    left: _vm.left + 'px',
  }),attrs:{"tabindex":"-1"},on:{"mouseover":_vm.showMenu}},[_vm._l((_vm.items),function(item,i){return _c('li',{key:i,style:({ order: item.position }),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();item.cbk || (function () {})}}},[(item.children)?_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}):_vm._e(),_vm._v(" "),(item.icon)?_c('i',{class:_vm.$fa(item.icon)}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(item.label))+"\n    "),_vm._v(" "),(item.children)?_c('ul',{staticClass:"sub-contex-menu"},_vm._l((item.children),function(child,j){return _c('li',{key:j,staticStyle:{"display":"list-item"},on:{"click":function($event){$event.stopPropagation();return child.cbk.apply(null, arguments)}}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t(child.label)))])])}),0):_vm._e()])}),_vm._v(" "),(['project', 'layer'].includes(_vm.context))?_c('li',{staticClass:"title g3w-long-text"},[('project' === _vm.context)?_c('div',[_vm._v(_vm._s(_vm.ApplicationState.project.getName()))]):('layer' === _vm.context)?_c('div',[_vm._v("\n      "+_vm._s(_vm.layer.title)+"\n      "),_c('div',{staticStyle:{"font-weight":"normal","font-size":"0.8em"}},[_vm._v("\n        "+_vm._s(_vm.getGeometryType(_vm.layer.id, _vm.layer.external))+"\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),('project' === _vm.context || _vm.hasMetadata(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showMetadata(_vm.layer && _vm.layer.id)}}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$t('Metadata'))+"\n    "),(_vm.layer && _vm.layer.metadata && _vm.layer.metadata.abstract)?_c('ul',{staticClass:"sub-contex-menu",staticStyle:{"border-radius":"0 3px 3px 0"}},[_c('li',{staticClass:"layer-menu-metadata-info",domProps:{"innerHTML":_vm._s(_vm.layer.metadata.abstract)}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.canEdit(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();0 === _vm.map_coords.length && _vm.startEditing(_vm.layer)}}},[_c('i',{staticClass:"fas fa-pencil-alt"}),_vm._v(" "+_vm._s(_vm.$t('Edit Layer'))+" \n    "),('map' === _vm.context)?_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('ul',{staticClass:"sub-contex-menu"},_vm._l((_vm.editableGeometryLayers()),function(layer){return _c('li',{key:layer.getId(),staticStyle:{"display":"list-item"},on:{"click":function($event){$event.stopPropagation();_vm.startEditing({ id: layer.getId() })}}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(layer.getName())+" ")])])}),0):_vm._e()]):_vm._e(),_vm._v(" "),(['project', 'layer'].includes(_vm.context) && _vm.layerstree.geolayer)?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showLegend.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-list"}),_vm._v(" "+_vm._s(_vm.$t('legend'))+"\n  ")]):_vm._e(),_vm._v(" "),('project' === _vm.context && _vm.layerstree.root)?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showEmbedModal.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-share-alt"}),_vm._v(" "+_vm._s(_vm.$t('Embed map'))+"\n  ")]):_vm._e(),_vm._v(" "),('layer' === _vm.context)?[(_vm.canZoom(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.zoomToLayer(_vm.layer)}}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "+_vm._s(_vm.$t('Zoom to Layer'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.canOpenAttributeTable(_vm.layer))?_c('li',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showAttributeTable(_vm.layer.id)}}},[_c('i',{staticClass:"fas fa-list-alt",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('Open Attribute Table'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isExternalLayer(_vm.layer))?_c('li',[_c('i',{staticClass:"fa fa-sort"}),_vm._v("\n      "+_vm._s(_vm.$t('layer_position.message'))+" ("+_vm._s(_vm.$t('layer_position.' + _vm.layer.position))+")\n      "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((['top', 'bottom']),function(position){return _c('li',{staticStyle:{"display":"list-item"},on:{"click":function($event){return _vm.setLayerPosition(position)}}},[(position === _vm.layer.position)?_c('span',{staticClass:"fas fa-circle",staticStyle:{"font-size":"0.5em","margin-right":"3px"}}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('layer_position.' + position),expression:"'layer_position.' + position"}]})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowStylesMenu(_vm.layer))?_c('li',[_c('i',{staticClass:"fas fa-palette"}),_vm._v("\n      "+_vm._s(_vm.$t('Style'))+" ("+_vm._s(_vm.layer.styles.find(function (s) { return s.current; }).name.toLowerCase())+")\n      "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((_vm.layer.styles),function(style){return _c('li',{key:style.name,staticStyle:{"display":"list-item"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerStyle(style.name)}}},[(style.current)?_c('span',{staticClass:"fas fa-circle",staticStyle:{"font-size":"0.8em"}}):_vm._e(),_vm._v("\n          "+_vm._s(style.name + (_vm.layer.styles.length > 1 && style.name === _vm.layer.defaultstyle ? (" (" + (_vm.$t('default')) + ")") : ''))+"\n        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.canShowOpacityPicker(_vm.layer))?_c('li',[_c('i',{staticClass:"fas fa-sliders-h"}),_vm._v("\n      "+_vm._s(_vm.$t('Opacity'))+" ("+_vm._s((_vm.layer.opacity / 100))+")\n      "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"100","step":"1","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalImageLayer(_vm.layer))?_c('li',[_c('i',{staticClass:"fas fa-sliders-h"}),_vm._v("\n      "+_vm._s(_vm.$t('Opacity'))+" ("+_vm._s(_vm.layer.opacity)+")\n      "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"display":"list-item"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layer.opacity),expression:"layer.opacity"}],attrs:{"type":"range","min":"0","max":"1","step":"0.01","list":"opacity-markers"},domProps:{"value":(_vm.layer.opacity)},on:{"change":_vm.onLayerOpacity,"__r":function($event){return _vm.$set(_vm.layer, "opacity", $event.target.value)}}}),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),(_vm.isExternalVectorLayer(_vm.layer))?_c('li',[_c('i',{staticClass:"fa fa-tint"}),_vm._v("\n      "+_vm._s(_vm.$t('Color'))+"\n      "),_c('i',{ref:"layer_color",staticStyle:{"width":"10px","height":"10px","border-radius":"10px","position":"absolute","right":"20px","margin-top":"4px"},style:({ backgroundColor: _vm.layer.color })}),_vm._v(" "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},[_c('li',{staticStyle:{"padding":"14px","background-color":"#E0E0E0"}},[_c('chrome-picker',{ref:"color_picker",staticStyle:{"width":"100%"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();},"hook:beforeDestroy":function () { return _vm.$refs.color_picker.$off(); },"input":_vm.onChangeColor},model:{value:(_vm.layer.color),callback:function ($$v) {_vm.$set(_vm.layer, "color", $$v)},expression:"layer.color"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.canShowFiltersMenu(_vm.layer))?_c('li',[_c('i',{staticClass:"fas fa-filter"}),_vm._v("\n      "+_vm._s(_vm.$t('Filters'))+"\n      "),_c('i',{staticClass:"fas fa-chevron-right",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"}}),_vm._v(" "),_c('ul',{staticClass:"sub-contex-menu"},_vm._l((_vm.layer.filters),function(filter){return _c('li',{key:filter.fid,staticStyle:{"display":"flex","justify-content":"space-between","align-items":"baseline"},on:{"click":function($event){$event.stopPropagation();return _vm.setLayerFilter(filter)}}},[(_vm.layer.filter.current && _vm.layer.filter.current.fid === filter.fid)?_c('span',{staticClass:"fas fa-circle",staticStyle:{"font-size":"0.5em","margin-right":"3px","justify-self":"flex-start"}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"5px"}},[_vm._v(_vm._s(filter.name))]),_vm._v(" "),_c('span',{staticClass:"fas fa-trash skin-border-color",staticStyle:{"color":"red","right":"0","padding-left":"10px","border-left":"2px solid"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteFilter(filter.fid)}}})])}),0)]):_vm._e(),_vm._v(" "),(_vm.canDownload(_vm.layer.id) || _vm.isExternalVectorLayer(_vm.layer))?_c('li',{attrs:{"disabled":_vm.ApplicationState.download},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showDownloadMenu(_vm.layer)}}},[_c('i',{staticClass:"fas fa-download",attrs:{"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.$t('Export'))+"\n    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.layers_url && 'layer' === _vm.context && !_vm.isExternalLayer(_vm.layer))?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.layers_url,"target":"_blank"}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      "+_vm._s(_vm.$t('Layers settings'))+"\n      "),_c('i',{staticClass:"fa fa-external-link-alt",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"},attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.copyCoords}},[_c('i',{staticClass:"fas fa-map-pin"}),_vm._v(_vm._s(_vm.map_coords.map(function (c) { return c.toFixed(2); }).join(', ')))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.queryCoords}},[_c('i',{staticClass:"far fa-question-circle"}),_vm._v(_vm._s(_vm.$t("What’s here?")))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.zoomIn}},[_c('i',{staticClass:"fas fa-search-plus"}),_vm._v(_vm._s(_vm.$t('Zoom in')))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.zoomOut}},[_c('i',{staticClass:"fas fa-search-minus"}),_vm._v(_vm._s(_vm.$t('Zoom out')))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.zoomHome}},[_c('i',{staticClass:"fas fa-home"}),_vm._v(_vm._s(_vm.$t('Fit map extent')))]):_vm._e(),_vm._v(" "),('map' === _vm.context && _vm.initConfig.mapcontrols.screenshot)?_c('li',{on:{"click":_vm.takeScreenshot}},[_c('i',{staticClass:"fas fa-camera-retro"}),_vm._v(_vm._s(_vm.$t('Screen capture')))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.showEmbedModal}},[_c('i',{staticClass:"fa fa-share-alt"}),_vm._v(_vm._s(_vm.$t('Embed map')))]):_vm._e(),_vm._v(" "),('map' === _vm.context && _vm.initConfig.mapcontrols.streetview)?_c('li',{on:{"click":_vm.showStreetView}},[_c('i',{staticClass:"fas fa-street-view"}),_vm._v(_vm._s(_vm.$t('StreetView')))]):_vm._e(),_vm._v(" "),('map' === _vm.context && _vm.initConfig.mapcontrols.annotation)?_c('li',{on:{"click":_vm.showAnnotation}},[_c('i',{staticClass:"fas fa-font"}),_vm._v(_vm._s(_vm.$t('Annotation')))]):_vm._e(),_vm._v(" "),('map' === _vm.context)?_c('li',{on:{"click":_vm.showLegend}},[_c('i',{staticClass:"fas fa-list"}),_vm._v(_vm._s(_vm.$t('legend')))]):_vm._e(),_vm._v(" "),(_vm.edit_url && ['project', 'map'].includes(_vm.context))?_c('li',[_c('a',{staticStyle:{"color":"initial"},attrs:{"href":_vm.edit_url,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();return _vm.closeMenu.apply(null, arguments)}}},[_c('i',[_c('svg',{staticStyle:{"height":"14px","vertical-align":"-1.5px","fill":"currentColor"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"m17.61 17.63 4.36-.02-4-3.98h-4.36v4l4 4.45z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m31.61 27.22-7.62-7.6-4.38.01v4.33l7.24 7.67h4.76z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18 25.18c-.68.16-1.17.2-1.9.2a9.77 9.77 0 0 1-9.68-9.88c0-5.57 4.4-9.78 9.68-9.78s9.48 4.2 9.48 9.78c0 .91-.15 1.96-.36 2.8l4.88 4.65a15 15 0 0 0 1.95-7.48C32.05 6.87 25.19.44 16 .44 6.86.44 0 6.84 0 15.47c0 8.68 6.86 15.2 16 15.2 2.36 0 4.23-.3 6.2-1.1L18 25.18z"}})])]),_vm._v("\n      "+_vm._s(_vm.$t('Project settings'))+"\n      "),_c('i',{staticClass:"fa fa-external-link-alt",staticStyle:{"position":"absolute","right":"0","margin-top":"3px"},attrs:{"aria-hidden":"true"}})])]):_vm._e()],2):_vm._e()}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("0.25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("0.50")]),_vm._v(" "),_c('option',{attrs:{"value":"75"}},[_vm._v("0.75")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"opacity-markers"}},[_c('option',[_vm._v("0")]),_vm._v(" "),_c('option',[_vm._v("0.25")]),_vm._v(" "),_c('option',[_vm._v("0.50")]),_vm._v(" "),_c('option',[_vm._v("0.75")]),_vm._v(" "),_c('option',[_vm._v("1")])])}]

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-efe643c8_0", { source: ".context-menu{background:#fafafa;border:1px solid #bdbdbd;border-radius:3px;display:block;list-style:none;margin:0;padding:0;position:fixed;min-width:150px;z-index:2;color:#000;outline:0;display:flex;flex-direction:column}.context-menu li ul{position:absolute;width:max-content;order:1;padding-left:0;background-color:#fff;color:#000}.context-menu li:not(:hover) ul{display:none}.context-menu li{border-bottom:1px solid #e0e0e0;margin:0;padding:8px 25px 8px 15px;display:flex;flex-direction:row}.context-menu li:not(.title){align-items:center}.context-menu li i{padding-right:3px;margin-right:6px;color:hsl(from var(--skin-color) h s calc(l - 20))!important}.context-menu li .click-to-copy{color:#000;opacity:1;margin-left:1ch;margin-right:-15px;margin-top:8px}.context-menu li .click-to-copy:hover{color:#fff!important;transform:scale(1.1)}.context-menu li.title{background:0 0!important;font-size:1.1em;font-weight:700;border-bottom-width:3px!important;flex-direction:column;max-width:250px;cursor:move!important;color:#000!important;border-bottom-color:var(--skin-color)!important}.context-menu li:last-child{border-bottom:none}.context-menu li:hover{color:#fafafa;cursor:pointer;background:hsl(from var(--skin-color) h s calc(l + 10))}.context-menu li .layer-menu-metadata-info{background-color:#fff;color:#000;padding:5px;max-width:200px;white-space:normal;overflow-y:auto;max-height:150px}.context-menu .item-text{margin-left:3px}.context-menu :is(ul,li){list-style-type:none}.context-menu li.inline-submenu{display:list-item;padding:0;text-indent:100%;line-height:0;overflow:hidden}.context-menu li.inline-submenu>*{display:none}.context-menu li.inline-submenu>ul{display:block;position:relative;left:0!important;width:100%;text-indent:0;line-height:initial}.context-menu li,.context-menu li.inline-submenu>ul>li{font-weight:700}.context-menu li li{font-weight:400}.context-menu .sub-contex-menu{border:1px solid #eee;border-left:0}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContextMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__